<style src="./style.scss">

</style>

<section class="mbsc-row featured-class">
  <header class="mbsc-col-12 mbsc-col-lg-8">
    <br><br>
    <h1>{classTitle}</h1>
    <p>
      D-NS Studio es un espacio multidisciplinario, 
      nuestro propósito es brindarte herramientas intertactivas 
      para que te diviertas, aprendas y te actives con nuestras clases.
      <br><br>
      Elige una disciplina y empieza a practicar hoy mismo, o simplemente explora nuestro contenido y aprende cosas nuevas cada día.<br>Cada día buscamos traer más diversidad a nuestra oferta.
      <br><br>
      Con una sola membresía podrás acceder a todas nuestras clases sin restricciones, 
      pero además nuestro compromiso es agregar al menos 4 nuevas clases cada semana.
      <br><br>
      Regístrate hoy y accede a nuestras clases gratuitas, y si te gustan adquiere tu membresía ahora para tener acceso a todo nuestro contenido sin límites.
  </header>
</section>
<article class="mbsc-row">
  <ClassGrid
    {categoryFilter}
  ></ClassGrid>
</article>

<script>
import { onMount, afterUpdate } from 'svelte';
import { AWSAuth, AWSAnalytics } from '@Services';

import Banner from '@Components/Banner/index.svelte';
import ClassGrid from '@Components/ClassGrid/index.svelte';
import CategoryGrid from '@Components/CategoryGrid/index.svelte';
import ClassExplorer from '@Components/ClassExplorer/index.svelte';
import ClassPlayer from '@Components/ClassPlayer/index.svelte';
import RelatedContent from '@Components/RelatedContent/index.svelte';

const DEBUG = document.location.protocol === 'http:' ? true : false;

export let categoryFilter = null;
let classTitle = 'Todas nuestras disciplinas sin salir de casa';

let isVisitor = true;

onMount(async () =>{
  AWSAuth.isAnonymous().then(response => {
    if (response === 'not authenticated') {
      isVisitor = true;
    }else if (response !== isVisitor) {
      isVisitor = response;
      if (DEBUG) console.log('updated! ' + isVisitor);
    }
  });
});
</script>
